
// region JS Imports

// region External Modules
import u from "umbrellajs"
import $ from "jquery"
// endregion External Modules

// Private Modules
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

import {
  onSignedIn,
} from "app/authentication/remote_state"
// Private Modules

// region Public Components
import BS3_Dropdown from "components/bootstrap3-like-dropdown"
// endregion Public Components

// region Private Components
import {
  Factory as LanguageSelectFactory,
} from "./components/language_select/index"
// endregion Private Components

// endregion JS Imports

const HAS_SMART_BANNER = "has-smart-banner"
const $navbar = $("#main-navbar")
const main_container = document.querySelector(".main-container") as Element

let smart_banner_is_shown = false

const getMainNavbar = () => {
  return u("#main-navbar")
}

function initAllMatchingElements() {
  BS3_Dropdown.init({
    scope:              ".main-navbar-mobile",
    dropdown_toggle:    ".dropdown-toggle",
    dropdown_container: ".dropdown",
  })
}

const init = () => {
  if (getMainNavbar().length !== 1) { return }

  LanguageSelectFactory.instance()

  WaitObjectByPathPromise("window._spacious_main_css_loaded").then(() => {
    initAllMatchingElements()

    $(document).on("ajaxSuccess", () => {
      // to wait for dom tree update before update
      // TODO: do these reinitialization on some events only instead globally
      setTimeout(initAllMatchingElements, 200)
    })

    onSignedIn(() => {
      initAllMatchingElements()
    })
  })
  .done()

  // This implementation would only be applied to those main navbar with class has-universal-search in mobile version only
  if (getMainNavbar().hasClass("has-universal-search") ) {

    // for changing navbar and filter bar sticky top positon if spacious searcher app download banner is shown
    if (document.querySelector(".layout-section--mobile-searcher-app-smart-banner--shown") && document.querySelector(".cell--mobile-apps--searcher-app--smart-banner--default-style") != null) {
      $navbar.addClass(HAS_SMART_BANNER)

      smart_banner_is_shown = true
    }

    // change position of filter bar when dismissing download banner
    $(".cell--mobile-apps--searcher-app--smart-banner--default-style__close-banner-button").on("click", () => {
      $navbar.removeClass(HAS_SMART_BANNER)

      // reset smart banner show flag to false
      smart_banner_is_shown = false
    })

    let last_scroll_top = 0

    $(window).scroll(() => {
      const page_container_height = main_container.getBoundingClientRect().height as number

      const current_scroll_top = $(window).scrollTop() || 0

      // need to make sure this part would be executed only when scrolling but not touching
      if (!document.body.classList.contains("page--filter--js-expanded") && Math.abs(current_scroll_top - last_scroll_top) > 20) {
        if (current_scroll_top > 46 && (current_scroll_top > last_scroll_top) && current_scroll_top < page_container_height) {
          if (smart_banner_is_shown) {
            $navbar.css({"transform": "translateY(-41px)", "transition": "transform 0.2s"})
          }
          else {
            $navbar.css({"transform": "translateY(-46px)", "transition": "transform 0.2s"})
          }
        }
        else {
          $navbar.css({"transform": "translateY(0)", "transition": "transform 0.2s"})
        }

        last_scroll_top = current_scroll_top
      }
    })
  }
}


export default {
  init,
  initAllMatchingElements,
}
